import moment from 'moment';

window.moment = moment;

export default moment;
